<template>
    <div v-bind:class="colorclass">
        <section class="progress-bar-container" id="progress">
            <div class="step-bar container">
                <template v-for="(page, index) in pages">
                    <div v-bind:class="{ active: index == currentPage }" v-bind:key="index" v-on:click="gotoPage(index)"
                         class="ball">
                        <img class="lock-icon" src="../../../static/icons/icon-jana-lukko.png" alt="lukko-kuvake"
                             v-if="!pageIsUnlocked(index)">
                        <div class="info_box">
                            <p>{{page.title.rendered}}</p>
                        </div>
                    </div>
                    <div class="bar" v-bind:key="index + 10000" v-show="index < pages.length-1"></div>
                </template>
            </div>
        </section>

        <b-carousel id="carousel1" v-show="!pagesLoading"
                    :interval=0
                    img-width="1024"
                    img-height="480"
                    v-model="currentPage"
                    @sliding-start="onSlideStart"
                    @sliding-end="onSlideEnd"
        >
            <b-carousel-slide v-for="(page, index) in pages" v-bind:key="page.id">
                <Page v-bind:pagedata="page" v-bind:isfirst="index==0" v-bind:islast="index==pages.length-1"
                      v-on:start="handleStart"
                      v-on:completed="unLockModule()"
                      v-on:casecompleted="unLockCase()"
                      v-on:next="$emit('next')"
                      v-on:imageClick="imagePopup">
                </Page>
            </b-carousel-slide>
        </b-carousel>

        <div class="container loader" v-show="pagesLoading">
            <h2>{{ $t('general.ladataan', currentLocale) }}</h2>
        </div>

        <div class="bottom-bar">
            <button class="button btn-bottom-left"
                v-on:click="prev">
                {{ $t('general.edellinen', currentLocale).toUpperCase() }}
            </button>
            <button class="button btn-bottom-left"
                v-on:click="next"
                v-show="pageIsUnlocked(this.currentPage+1) && this.currentPage < this.pages.length">
                {{ $t('general.seuraava', currentLocale).toUpperCase() }}
            </button>
        </div>
    </div>
</template>
<script>
  import Page from './Page.vue'
  import secretStore from '../../utils/localstorage'
  import keywordDictionary from '../../utils/dictionary'

  export default {
    data: function () {
      return {
        pagesLoading: false,
        pages: [],
        currentPage: 0,
        slide: 0,
        sliding: null,
        completedModules: [],
      }
    },
    components: {
      Page,
    },
    props: {
      pid: null,
      pids: [],
      colorclass: ''
    },
    watch: {
      'pid': function (pid) {
        if (pid != null) {
          this.fetchPages()
        }
      }
    },
    created: function () {
      this.fetchKeywords()
    },

    methods: {
      handleStart: function () {
        this.currentPage++
      },
      gotoPage: function (index) {
        if (this.pageIsUnlocked(index)) {
          this.currentPage = index
        }
      },
      prev: function (e) {
        // e.preventDefault();
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        if (this.currentPage > 0) {
          this.currentPage--
        }
      },
      next: function (e) {
        // v-smooth-scroll v-smoothscroll="{ duration : 500, callback: callback , context : undefined , axis :'y' }"
        // e.preventDefault();
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        if (this.currentPage < this.pages.length && this.pageIsUnlocked(this.currentPage + 1)) {
          this.currentPage++
        }
      },
      pageIsUnlocked: function (index) {
        var previous = this.pages[Math.max(0, index - 1)]
        if (previous !== undefined && previous.acf.case_tehtava) { // is there case quiz and if is it completed?
          return secretStore.getValue(this.pid + 'c')
        }

        if (index == this.pages.length - 1) { // next page is last
          return secretStore.getValue(this.pid)
        }

        return true
      },
      unLockModule: function () {
        this.completedModules.push(this.pid)
        secretStore.setValue(this.pid, true)
        // console.log("unlocked: " + secretStore.getValue(this.pid) )
        this.currentPage++
      },
      unLockCase: function () {
        secretStore.setValue(this.pid + 'c', true)
        this.currentPage++
      },
      fetchPages: function () {
        this.pagesLoading = true
        var pageId = this.pid

        if(this.$route.params.locale == 'sv'){
            pageId = this.pids[1]
        }
        if(this.$route.params.locale == 'en'){
            pageId = this.pids[2]
        }
       
        this.axios.get('pages/?parent=' + pageId + '&filter[orderby]=menu_order&order=asc').then((response) => {
          // console.log(response.data)
          this.pages = response.data
          this.currentPage = 0
          this.pagesLoading = false
        })
      },
      fetchKeywords: function () {
        this.pagesLoading = true
        this.axios.get('posts/?per_page=100').then((response) => {
          keywordDictionary.init(response.data)
          this.fetchPages()
        })
      },
      onSlideStart (slide) {
        this.sliding = true
      },
      onSlideEnd (slide) {
        this.sliding = false
        // console.log(slide)
      },
      imagePopup: function (src) {
        this.$emit('imagePopup', src)
      }
    },
    computed: {
        currentLocale() {
            return this.$route.params.locale
        },
    },
  }
</script>
<style scoped lang="scss">

    // Loader
    .loader {
        padding: 4em;
        text-align: center;
        h2 {
            font-size: 24px;
            //color: #059DF3;
            font-weight: bold;
        }
    }

    .page-carousel {
        height: auto;
    }

    // Progress Bar

    .progress-bar-container {
        background: #F5F5F5;
    }

    .step-bar {
        padding: 1rem 6rem;
        display: flex;
        align-items: center;
        .ball {
            position: relative;
            background: white;
            width: 40px;
            height: 40px;
            background-size: contain;
            background-repeat: no-repeat;
            border-radius: 50%;
            box-shadow: 0 3px rgba(110, 110, 110, 0.35);
            .info-icon {
                display: none;
            }
            .lock-icon {
                display: block;
                width: 40px;
            }
            &.completed {
                &:hover {
                    .info-icon {
                        display: block;
                        margin-left: 17px;
                        width: 6px;
                        margin-top: 8px;
                    }
                    .info_box {
                        width: 220px;
                        text-align: center;
                        display: block;
                        top: 50px;
                        left: -90px;
                        padding: 1rem;
                        color: #fff;
                        position: absolute;
                        border-radius: 8px;
                        z-index: 999;
                        p {
                            margin: 0;
                            color: white;
                            font-weight: bold;
                        }
                    }
                    .info_box:after {
                        bottom: 100%;
                        left: 50%;
                        border: solid transparent;
                        content: " ";
                        height: 0;
                        width: 0;
                        position: absolute;
                        pointer-events: none;
                        border-color: rgba(255, 255, 255, 0);
                        border-width: 5px;
                        margin-left: -5px;
                    }
                }
            }
            &.active {

            }
            .info_box {
                display: none;
            }

        }
        .bar {
            background-color: #BEDBDF;
            flex-grow: 1;
            height: 10px;
        }
        .blue {
            background-color: dodgerblue;
        }
        @media(max-width: 767.98px) {
            padding: 1rem;
        }
    }

    // Bottombar

    .bottom-bar {
        height: 100px;
        width: 100%;
        justify-content: space-between;
        flex-direction: row;
        padding: 1rem 5rem;
        display: flex;
        align-items: center;
        .btn-bottom-left, .btn-bottom-right {
            background: white;
            padding: 1rem 3rem;
            color: #414141;
            text-decoration: none;

        }

        a {
            margin: 0;
        }
        @media(max-width: 767.98px) {
            padding: 1rem;
            .btn-bottom-left {
                padding: 0.5rem 1rem;
            }
        }
    }

    // Color codes
    $color-red: #EF5050;
    $color-blue: #00BBD6;
    $color-yellow: #F4BC21;
    $color-green: #8CC63F;
    $color-purple: #917DF8;

    .template-red {
        .ball, .info {
            &:hover {
                background: $color-red;
                .info_box {
                    background: $color-red;
                    &:after {
                        border-bottom-color: $color-red;
                    }
                }
                .bottom-info-box {
                    background: $color-red;
                    &:after {
                        border-top: solid 10px $color-red;
                    }
                }
            }
        }

        .loader {
            h2 {
                color: $color-red;
            }
        }
    }

    .template-blue {

        .ball, .info {
            &:hover {
                background: $color-blue;
                .info_box {
                    background: $color-blue;
                    &:after {
                        border-bottom-color: $color-blue;
                    }
                }
                .bottom-info-box {
                    background: $color-blue;
                    &:after {
                        border-top: solid 10px $color-blue;
                    }
                }
            }
        }

        .loader {
            h2 {
                color: $color-blue;
            }
        }
    }

    .template-yellow {

        .ball, .info {
            &:hover {
                background: $color-yellow;
                .info_box {
                    background: $color-yellow;
                    &:after {
                        border-bottom-color: $color-yellow;
                    }
                }
                .bottom-info-box {
                    background: $color-yellow;
                    &:after {
                        border-top: solid 10px $color-yellow;
                    }
                }
            }
        }

        .loader {
            h2 {
                color: $color-yellow;
            }
        }
    }

    .template-green {

        .ball, .info {
            &:hover {
                background: $color-green;
                .info_box {
                    background: $color-green;
                    &:after {
                        border-bottom-color: $color-green;
                    }
                }
                .bottom-info-box {
                    background: $color-green;
                    &:after {
                        border-top: solid 10px $color-green;
                    }
                }
            }
        }

        .loader {
            h2 {
                color: $color-green;
            }
        }
    }

    .template-purple {

        .ball, .info {
            &:hover {
                background: $color-purple;
                .info_box {
                    background: $color-purple;
                    &:after {
                        border-bottom-color: $color-purple;
                    }
                }
                .bottom-info-box {
                    background: $color-purple;
                    &:after {
                        border-top: solid 10px $color-purple;
                    }
                }
            }
        }

        .loader {
            h2 {
                color: $color-purple;
            }
        }
    }

    // Bootstrap carousel styles
    .carousel {
        position: relative;
    }

    .carousel-inner {
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .carousel-item {
        position: relative;
        display: none;
        -ms-flex-align: center;
        align-items: center;
        width: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-perspective: 1000px;
        perspective: 1000px;
    }

    .carousel-item.active,
    .carousel-item-next,
    .carousel-item-prev {
        display: block;
        transition: -webkit-transform 0.6s ease;
        transition: transform 0.6s ease;
        transition: transform 0.6s ease, -webkit-transform 0.6s ease;
    }

    @media screen and (prefers-reduced-motion: reduce) {
        .carousel-item.active,
        .carousel-item-next,
        .carousel-item-prev {
            transition: none;
        }
    }

    .carousel-item-next,
    .carousel-item-prev {
        position: absolute;
        top: 0;
    }

    .carousel-item-next.carousel-item-left,
    .carousel-item-prev.carousel-item-right {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }

    @supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {
        .carousel-item-next.carousel-item-left,
        .carousel-item-prev.carousel-item-right {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    .carousel-item-next,
    .active.carousel-item-right {
        -webkit-transform: translateX(100%);
        transform: translateX(100%);
    }

    @supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {
        .carousel-item-next,
        .active.carousel-item-right {
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
    }

    .carousel-item-prev,
    .active.carousel-item-left {
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
    }

    @supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {
        .carousel-item-prev,
        .active.carousel-item-left {
            -webkit-transform: translate3d(-100%, 0, 0);
            transform: translate3d(-100%, 0, 0);
        }
    }

    .carousel-fade .carousel-item {
        opacity: 0;
        transition-duration: .6s;
        transition-property: opacity;
    }

    .carousel-fade .carousel-item.active,
    .carousel-fade .carousel-item-next.carousel-item-left,
    .carousel-fade .carousel-item-prev.carousel-item-right {
        opacity: 1;
    }

    .carousel-fade .active.carousel-item-left,
    .carousel-fade .active.carousel-item-right {
        opacity: 0;
    }

    .carousel-fade .carousel-item-next,
    .carousel-fade .carousel-item-prev,
    .carousel-fade .carousel-item.active,
    .carousel-fade .active.carousel-item-left,
    .carousel-fade .active.carousel-item-prev {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }

    @supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {
        .carousel-fade .carousel-item-next,
        .carousel-fade .carousel-item-prev,
        .carousel-fade .carousel-item.active,
        .carousel-fade .active.carousel-item-left,
        .carousel-fade .active.carousel-item-prev {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    .carousel-control-prev,
    .carousel-control-next {
        position: absolute;
        top: 0;
        bottom: 0;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        width: 15%;
        color: #212529;
        text-align: center;
        opacity: 0.5;
    }

    .carousel-control-prev:hover, .carousel-control-prev:focus,
    .carousel-control-next:hover,
    .carousel-control-next:focus {
        color: #212529;
        text-decoration: none;
        outline: 0;
        opacity: .9;
    }

    .carousel-control-prev {
        left: 0;
    }

    .carousel-control-next {
        right: 0;
    }

    .carousel-control-prev-icon,
    .carousel-control-next-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: transparent no-repeat center center;
        background-size: 100% 100%;
    }

    .carousel-control-prev-icon {
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E");
    }

    .carousel-control-next-icon {
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E");
    }

    .carousel-indicators {
        position: absolute;
        right: 0;
        bottom: 10px;
        left: 0;
        z-index: 15;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: center;
        justify-content: center;
        padding-left: 0;
        margin-right: 15%;
        margin-left: 15%;
        list-style: none;
    }

    .carousel-indicators li {
        position: relative;
        -ms-flex: 0 1 auto;
        flex: 0 1 auto;
        width: 30px;
        height: 3px;
        margin-right: 3px;
        margin-left: 3px;
        text-indent: -999px;
        cursor: pointer;
        background-color: rgba(255, 255, 255, 0.5);
    }

    .carousel-indicators li::before {
        position: absolute;
        top: -10px;
        left: 0;
        display: inline-block;
        width: 100%;
        height: 10px;
        content: "";
    }

    .carousel-indicators li::after {
        position: absolute;
        bottom: -10px;
        left: 0;
        display: inline-block;
        width: 100%;
        height: 10px;
        content: "";
    }

    .carousel-indicators .active {
        background-color: #fff;
    }

    .carousel-caption {
        color: #212529;
        position: absolute;
        right: 15%;
        bottom: 20px;
        left: 15%;
        z-index: 10;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
    }

</style>


// WEBPACK FOOTER //
// src/views/components/Transit.vue